import React, { useState } from "react";
import emailjs from "emailjs-com";

const Result = () => {
  return (
    <p className="success-message">
      Thank you for reaching out, we will get back to you soon!
    </p>
  );
};

function ContactForm({ formStyle }) {
  const [result, showResult] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_o33oelw",
        "template_bza7wrd",
        e.target,
        "OCNSwkE6NoP9nEw--",
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        },
      );
    e.target.reset();
    showResult(true);
  };

  return (
    <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
      <div className="form-group row row--0">
        <input type="text" name="fullname" placeholder="Your Name" required />
      </div>

      <div className="form-group row row--0">
        <input type="email" name="email" placeholder="Email Address" required />
      </div>

      <div className="form-group row row--0">
        <input type="text" name="phone" placeholder="Phone Number" required />
      </div>

      <div className="form-group row row--0">
        <input type="text" name="subject" placeholder="Subject" required />
      </div>

      <div className="form-group row row--0">
        <textarea name="message" placeholder="Your Message" required></textarea>
      </div>

      <div className="form-group">
        <button className="btn-default btn-large">Submit</button>
      </div>

      <div className="form-group">{result ? <Result /> : null}</div>
    </form>
  );
}
export default ContactForm;
